
import store from '../store/modules/store.main'

//Finds the basket icon counter in header and injects amount from state
function injectNewHeaderCartData() {
    const headerCartIcon = document.querySelector('[data-js="header-basket-amount"]')
    const headerCartProductList = document.querySelector('[data-js="basket-popup-append"]');

    headerCartIcon.innerHTML = store.state.cartIconAmount
    headerCartProductList.innerHTML = store.state.cartPopupProductList
    headerCartIcon.className += ' show';
}

export default injectNewHeaderCartData